import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HelperService, ParameterClass } from '../helpers/helper.service';
import { User } from '../models/user';
import { filterationParams } from '../params/params';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private http: HttpClient, private _helper: HelperService) { }

  getUsers(externalParams?: any) {
    let params = new filterationParams
    return this._helper.CallRequestList(`users/users`, this._helper.CreateRequestParameters(externalParams ? externalParams : params.notPaginationParams))
  }

  getUser(id: number) {
    return this._helper.CallRequestList(`users/users/${id}`)
  }

  updateProfile(model: any) {
    return this._helper.createFormData(`users/profile`, model)
  } 
}
